<template>
  <div>
    <b-modal id="modalEditEmergencyCalls" ref="modalEditEmergencyCalls" :title="$t('Emergency calls')" hide-footer @shown="shown">
      <div v-if="editItem">
        <b-form-group :disabled="editItem.id === 1" :label="$t('Service')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="optionsServices" v-model="editItem.service_id"/>
        </b-form-group>
        <b-form-group >
          <b-button size="sm" @click="modalTelZone">{{ $t('Add zone') }}</b-button>
          <b-button size="sm" @click="modalTelDirection">{{ $t('Add direction') }}</b-button>
        </b-form-group>
        <b-table striped hover small
          :items="items"
          :fields="fields">
          <template v-slot:cell(actions)="row">
            <b-button size="sm" @click.stop="ClickOnDeleteButton(row)" id="transparent">
              <b-img :src='deleteImage'/>
            </b-button>
          </template>
        </b-table>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save')}}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalEditEmergencyCalls.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal ref="modalTelephoneZones" :title="$t('Telephone zones')" hide-footer>
      <b-table striped hover small id="tablereport" responsive
        :items="telZones"
        :fields="telZonesfields"
        selectable
        @row-selected="onRowSelectedZones"
        select-mode="single">
      </b-table>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addZones">{{ $t('Save')}}</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalTelephoneZones.hide">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal ref="modalTelephoneDirections" :title="$t('Telephone directions')" hide-footer size="lg">
      <b-table striped hover small id="tablereport" responsive
        :items="telDirections"
        :fields="telDirectionsfields"
        selectable
        @row-selected="onRowSelectedDirections"
        select-mode="single">
      </b-table>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addDirections">{{ $t('Save')}}</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalTelephoneDirections.hide">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    editItem: null
  },
  data () {
    return {
      selectedDirections: null,
      selectedZones: null,
      deleteImage: require('@/assets/img/document_delete.png'),
      items: [],
      fields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      telZonesfields: [
        {key: 'zone_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'create_date', label: this.$i18n.t('Created on'), sortable: true},
        {key: 'update_date', label: this.$i18n.t('Updated on'), sortable: true},
        {key: 'supplier_id', label: this.$i18n.t('Supplier id'), sortable: true}
      ],
      telDirectionsfields: [
        {key: 'zone_id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'create_date', label: this.$i18n.t('Created on'), sortable: true},
        {key: 'update_date', label: this.$i18n.t('Updated on'), sortable: true},
        {key: 'zones', label: this.$i18n.t('Zone'), sortable: true},
        {key: 'calling_prefix', label: this.$i18n.t('Calling prefix'), sortable: true},
        {key: 'called_prefix', label: this.$i18n.t('Called prefix'), sortable: true}
      ]
    }
  },
  methods: {
    save () {
      if (this.editItem.service_id === -1) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select service'), 'Error')
        return
      }
      if (!this.items.length) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Zones/directions table is empty'), 'Error')
        return
      }
      for (let el of JSON.parse(JSON.stringify(this.$store.getters['Settings/EMERGENCY_CALLS']))) {
        if (el.service_id === this.editItem.service_id) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Service is already in use'), 'Error')
          return
        }
      }

      this.editItem.tel_directions = []
      for (let el of this.items) {
        if (el.dir_id) {
          let newEl = el.dir_id
          this.editItem.tel_directions.push(newEl)
        } else if (el.zone_id) {
          let newEl = el.zone_id
          this.editItem.tel_directions.push(newEl)
        } else {
          let newEl = el.id
          this.editItem.tel_directions.push(newEl)
        }
      }
      let response = this.$store.dispatch('Settings/CREATE_UPDATE_EMERGENCY_CALLS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_EMERGENCY_CALLS')
          this.$refs.modalEditEmergencyCalls.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    ClickOnDeleteButton (item) {
      this.items = this.items.filter((value) => {
        return value.id !== item.item.id
      })
    },
    shown () {
      this.items = []
      for (let el of this.editItem.tel_directions) {
        let newEl = {}
        newEl.id = el
        if (newEl.id < 999999) {
          for (let zonesEl of this.$store.getters['Tariffing/TEL_ZONES']) {
            if (newEl.id === zonesEl.zone_id) {
              newEl.name = zonesEl.name
              break
            }
          }
        } else {
          for (let directionEl of this.$store.getters['Tariffing/TEL_DIRECTIONS']) {
            if (newEl.id === directionEl.dir_id) {
              newEl.name = directionEl.name
              break
            }
          }
        }
        this.items.push(newEl)
      }
    },
    onRowSelectedZones (selected) {
      this.selectedZones = selected[0]
    },
    onRowSelectedDirections (selected) {
      this.selectedDirections = selected[0]
    },
    modalTelZone () {
      this.selectedZones = null
      this.$refs.modalTelephoneZones.show()
    },
    modalTelDirection () {
      this.selectedDirections = null
      this.$refs.modalTelephoneDirections.show()
    },
    addZones () {
      if (!this.selectedZones) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select telephone zone'), 'Error')
        return
      }
      for (let el of this.items) {
        if (this.selectedZones.zone_id === el.id) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('This telephone zone is already selected'), 'Error')
          return
        }
      }

      this.selectedZones.id = this.selectedZones.zone_id
      this.items.push(this.selectedZones)
      this.$refs.modalTelephoneZones.hide()
    },
    addDirections () {
      if (!this.selectedDirections) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select telephone direction'), 'Error')
        return
      }
      for (let el of this.items) {
        if (this.selectedDirections.dir_id === el.id) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('This telephone direction is already selected'), 'Error')
          return
        }
      }

      this.selectedDirections.id = this.selectedDirections.dir_id
      this.items.push(this.selectedDirections)
      this.$refs.modalTelephoneDirections.hide()
    }
  },
  computed: {
    optionsServices () {
      let services = this.$store.getters['Tariffing/SERVICES'].filter((val) => {
        return val.service_type === 6 && (val.parent_id !== val.service_id)
      })
      for (let el of services) {
        el.value = el.service_id
        el.text = el.service_name + ' (' + el.service_id + ')'
      }
      let newEl = {
        value: 0,
        text: this.$t('All')
      }
      services.push(newEl)
      return services
    },
    telZones () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TEL_ZONES']))
      for (let el of copy) {
        el.create_date = moment(Number(el.create_date) * 1000).format('DD-MM-YYYY HH:MM')
        el.update_date = moment(Number(el.update_date) * 1000).format('DD-MM-YYYY HH:MM')
      }
      return copy
    },
    telDirections () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TEL_DIRECTIONS']))
      for (let el of copy) {
        el.create_date = moment(Number(el.create_date) * 1000).format('DD-MM-YYYY HH:MM')
        el.update_date = moment(Number(el.update_date) * 1000).format('DD-MM-YYYY HH:MM')
        for (let zonesEl of JSON.parse(JSON.stringify(this.$store.getters['Tariffing/TEL_ZONES']))) {
          if (el.zone_id === zonesEl.zone_id) {
            el.zones = zonesEl.name + ' (' + zonesEl.zone_id + ')'
            break
          }
        }
      }
      return copy
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/telephony/emergencyCalls/editModal.vue